import React from "react";
import { ArrowRight } from "lucide-react";
import { SX, TX } from "./studioTokens";

const STARTER_TEMPLATES = [
  {
    id: "invoice",
    title: "Invoice Extractor",
    desc: "Extract vendor, amounts, dates and line items from invoices.",
    fields: 10,
  },
  {
    id: "contract",
    title: "Contract Analyzer",
    desc: "Extract parties, dates, governing law and contract value.",
    fields: 7,
  },
  {
    id: "receipt",
    title: "Receipt Scanner",
    desc: "Pull merchant, total, payment method and items from receipts.",
    fields: 5,
  },
  {
    id: "po",
    title: "Purchase Order Reader",
    desc: "Parse PO numbers, items, delivery dates and totals.",
    fields: 7,
  },
];

const QuickStart = ({ onSelectTemplate }) => (
  <div className={`${SX.card} p-6`}>
    <div className="mb-4">
      <div className={TX.sectionHeading}>Quick Start</div>
      <div className={`${TX.helper} mt-0.5`}>Start with a template and customize it for your needs.</div>
    </div>
    <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 xl:grid-cols-4">
      {STARTER_TEMPLATES.map((t) => (
        <div
          key={t.id}
          onClick={() => onSelectTemplate?.(t)}
          className={`p-4 cursor-pointer group ${SX.card} ${SX.cardHover}`}
        >
          <div className={`${TX.cardTitle} group-hover:text-[#893F82] transition-colors`}>{t.title}</div>
          <div className="text-[13px] text-[#52525B] mt-2.5 leading-[1.5]">{t.desc}</div>
          <div className="flex items-center justify-between mt-4">
            <span className="text-[12px] text-[#8A8A90] font-semibold">{t.fields} Fields</span>
            <ArrowRight size={14} className="text-[#A04A97]" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default QuickStart;
